<div class="cookie-consent-banner" *ngIf="showBanner" [@slideIn]>
  <div class="cookie-content">
    <div class="cookie-text">
      <p>
        {{ "cookie_consent_message" | translate }}
        <a
          class="privacy-link"
          href="javascript:void(0)"
          (click)="goToPrivacyPolicy()"
        >
          {{ "privacy_policy_short" | translate }}.
        </a>
      </p>
    </div>
    
    <div class="cookie-actions">
      <app-ds-button 
        tone="primary"
        class="accept-button"
        (pressed)="acceptCookies()"
      >
        {{ "cookie_accept" | translate }}
      </app-ds-button>
    </div>
  </div>
</div>
